import React from 'react'
import { MdBlock, MdCreate, MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md'
import ReactPaginate from 'react-paginate'
import { useNavigate } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'

function AllDeposit() {
  const navigate = useNavigate()
  return (
    <>
        <div className='px-4 mt-4'>
            <div className='container-fluid p-0'>
                <div className='row'>
                    <h4 className='header-title pb-3 text-muted'>All Deposit</h4>
                    <div className='col-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <div className='d-flex justify-content-between align-items-center mb-2'>
                                    <div className='d-flex'> 
                                        <input
                                            type='text'
                                            className='form-control me-2'
                                            id='search'
                                            name='search'
                                            placeholder='Transaction id' 
                                            autoComplete='off'
                                        />
                                    </div> 
                                </div> 
                                <div className='table-responsive'>
                                    <table
                                    id='scroll-horizontal-datatable'
                                    className='table w-100 nowrap'
                                    >
                                        <thead>
                                            <tr>
                                            <th>SN</th>   
                                            <th>Name</th>
                                            <th>Gateway Name</th>
                                            <th>Amount</th>
                                            <th>Charge</th>
                                            <th>USD Amount</th>
                                            <th>Status</th>
                                            <th>Transaction ID</th>
                                            </tr>
                                        </thead>
                                        <tbody> 
                                            <tr>
                                                <th scope='row'>1</th>   
                                                <td style={{cursor:'pointer'}}
                                                 onClick={()=>navigate('/user/view-user', { state : {type :1}})}>Demos</td>
                                                <td>PayPal</td>
                                                <td>100 USD</td>
                                                <td>2 USD</td>
                                                <td>102 USD</td>
                                                <td> 
                                                    <span className='badge badge-success-lighten'>complete</span>  
                                                </td> 
                                                <td>PBFQ156OES6G</td>
                                            </tr> 
                                            
                                            <tr>
                                              <th scope='row'>2</th>   
                                              <td style={{cursor:'pointer'}}
                                               onClick={()=>navigate('/user/view-user', { state : {type :1}})}>Test</td>
                                              <td>Stripe</td>
                                              <td>200 USD</td>
                                              <td>4 USD</td>
                                              <td>204USD</td>
                                              <td> 
                                                  <span className='badge badge-danger-lighten'>incomplete</span>  
                                              </td> 
                                              <td>DMGCZC2PXJKH</td>
                                            </tr>   
                                        </tbody>
                                    </table>                    
                                </div>
                                <ReactPaginate
                                    className='pagination' 
                                    previousLabel={<MdKeyboardArrowLeft className='fs-4'/>}
                                    nextLabel={<MdKeyboardArrowRight className='fs-4'/>}
                                    breakLabel={'...'}
                                    containerClassName={'pagination-container'}
                                    activeClassName={'pagination-active-page'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default AllDeposit
